"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _md = _interopRequireDefault(require("md5"));
var _jsonStableStringify = _interopRequireDefault(require("json-stable-stringify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(obj) {
  return (0, _md["default"])((0, _jsonStableStringify["default"])(obj));
};